/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type group_presence_GroupPresenceSegmentResponse = {
    employee_id: string;
    ended_at: string | null;
    ended_reason: group_presence_GroupPresenceSegmentResponse.ended_reason | null;
    group_id: string;
    id: string;
    source: group_presence_GroupPresenceSegmentResponse.source;
    started_at: string;
};
export namespace group_presence_GroupPresenceSegmentResponse {
    export enum ended_reason {
        EMPLOYEE = 'employee',
        SWITCH = 'switch',
        SHIFT_END = 'shift_end',
        DAY_END = 'day_end',
        ADMIN = 'admin',
    }
    export enum source {
        EMPLOYEE_APP = 'employee_app',
        EMPLOYEE_APP_LATE = 'employee_app_late',
        ADMIN = 'admin',
    }
}

